<template>
  <div class="browse_details" v-if="hide">
    <div class="browse_detailsnav">
      <div class="evolution_left_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="evolution_txt" style="cursor: pointer;" @click="tiao">
          首页 <span class="span1">></span>
          <span class="span1" @click.stop="tiao2">{{list2.journalName}}</span>
          <span class="span1">></span>
          <span class="span2" @click.stop="tiao2">{{list2.yearVolumeIssue}}</span>

        </div>
      </div>

      <div class="browse_detailnav1">
        <div class="browse_top">
          <div class="spanone">
            《{{list2.journalName}}》<span class="span2">{{list2.yearVolumeIssue}}</span>
          </div>
        </div>

        <div class="bigMain">

          <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>目次</h4>
                <p></p>
                <p></p>
            </div>
          </div>


          <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>述评</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

            <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>专题报告</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

            <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>指南与共识</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

            <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>心率失常研究</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

            <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>临床研究</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

            <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>静脉注射丙泊酚致癫痫样先写：</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

          <div class="muci">
              <div class="dian"> </div>
              <div class="muciDiv">
                  <h4>基础与试验研究</h4>
                  <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                  <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
              </div>
            </div>

            <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>病例报告</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

           <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>综述</h4>
                <p>阿萨德奶奶是电视的阿萨德奶奶萨德奶奶是奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的阿萨德奶奶是电视的</p>
                <p>定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你定八十记得拿你</p>
            </div>
          </div>

           <div class="muci">
            <div class="dian"> </div>
            <div class="muciDiv">
                <h4>读者 作者 编者</h4>
                <p>欢迎关注《中国循环杂志》微信和微博</p>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        hide: false,
        list: [ ],//相关推荐
        list2: [],
      }
    },

    methods: {
      //下载
      down(contentId){
        var that = this;
        that.$httphelper.GetContentFilePath({
          "journalId": 201607080003,
          "contentId": contentId,
          "downType": 1
        }).then(res => {
          if(res.code==200){
            window.open(res.data);
            that.$loading.hideLoading();
          }else{
            that.$alert('没有附件', '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      tiao(){
        this.$router.push({path:'/home'});
      },
      tiao2(){
        this.$router.push({path:'/browse'});
      },
      //获取内容详情
      GetContentInfo(){
        sessionStorage.setItem('routerIndex',4);
        var year = this.$route.query.year;
        var issue = this.$route.query.issue;
        var issuecid = this.$route.query.issuecid;
        var that = this;
        that.$httphelper.GetContentInfo({
          "journalId": 201607080003,
          "year": Number(year),
          "issue": Number(issue),
          "channelId": 0,
          "contentId": Number(issuecid),
          "dataSourceType": 3,
          "dataShowType": 1
        }).then(res => {
          if(res.code==200){
            that.list2 = res.data.issueContentInfoResult || '';
            that.$loading.hideLoading();
            that.hide = true;
          }else{
            that.hide = true;
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].id){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
    },
    created() {
      console.log('执行')
      this.GetContentInfo();
    }
  }
</script>

<style lang="scss" scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .browse_details{
    width: 100%;
    min-width: 1366px;
    background-color: #FFFFFF;
    .browse_detailsnav{
      width: 85%;
      margin: 0 auto;
      overflow: hidden;
      margin-top: 24px;
      padding-bottom: 43px;
      .bigMain{
        width: 96.8%;
        border: 1px solid #ccc;
        margin-top: 20px;
        padding-left: 50px;
        .dian{
            width: 10px;
            height: 10px;
            background: #2A2D3E;
            margin-right: 20px;
            float: left;
            margin-top: 6px;
          clip-path: polygon(50% 0,100% 50%,50% 100%,0 50%);
          transition:1s clip-path;
        }
        .muci{
          width: 100%;
          margin-top: 30px;
           .muciDiv{
          width: 100%;
             p{
               margin-left: 30px;
              margin-top: 5px;
             }
           }
        }
      }


      .evolution_left_txt {
        width: 100%;
        overflow: hidden;
        margin-bottom: 25px;
        .evolution_tu {
          width: 19px;
          height: 17px;
          float: left;
        }

        .evolution_txt {
          float: left;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #010101;

          .span1 {
            margin: 0 5px;
          }

          .span2 {
            color: var(--xt);
          }
        }
      }
      .browse_detailnav1{
        width: 100%;
        margin-bottom: 18px;
        .browse_top{
          width: 100%;
          background-color: #E4E4E4;
          overflow: hidden;
          .spanone{
            width: 50%;
            overflow: hidden;
            margin: 0 auto;
            text-align: center;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            line-height: 46px;
            .span2{
              color: var(--xt);
              margin: 0 30px;
            }
          }
        }
        .browse_bottom{
          width: 99.8%;
          border: 1px solid #EBEBEB;
          border-top: none;
          padding: 40px 0 59px 0;
          position: relative;
          .browse_down{
            cursor: pointer;
            width: 129px;
            height: 44px;
            background: var(--xt);
            text-align: center;
            color: #FFFFFF;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 44px;
            position: absolute;
            right: 45px;
            top: 52px;
            span{
              font-size: 22px;
              margin-right: 9px;
            }
          }
          .browse_txt1{
            width: 100%;
            text-align: center;
            font-size: 24px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            line-height: 24px;
            margin-bottom: 20px;
          }
          .browse_txt2{
            width: 50%;
            margin: 0 auto;
            text-align: center;
            margin-bottom: 17px;
            span{
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              line-height: 16px;
            }
          }
          .browse_txt3{
            width: 100%;
            text-align: center;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #959595;
            line-height: 15px;
            margin-bottom: 31px;
          }
          .browse_txt4,.browse_txt5{
            width: 95%;
            color: #959595;
            line-height: 25px;
            margin: 0 auto;
            margin-bottom: 10px;
          }
          .browse_txt5{
            margin-bottom: 0;
          }
        }
        .browse_abstract{
          width: 99.8%;
          border: 1px solid #EBEBEB;
          padding: 23px 0 48px 0;
          .browse_abstractnav{
            width: 95%;
            margin: 0 auto;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 30px;
            .browse_txt1{
              width: 100%;
              margin-bottom: 20px;
              font-size: 18px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              line-height: 17px;
            }
            .browse_txt2{
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              line-height: 30px;
              .browse_english{
                margin-top: 35px;
                margin-bottom: 10px;
              }
            }
            .browse_txt3{
              width: 100%;
              margin-top: 35px;
              div{
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                line-height: 30px;
                span{
                  font-weight: bold;
                }
              }
            }
          }
        }
        .browse_literature{
          width: 99.8%;
          padding: 32px 0 36px 0;
          margin-top: 20px;
          .can{
            width: 95%;
            margin: 0 auto;
            .cankao{
              width: 100%;
              margin-bottom: 30px;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              line-height: 16px;
            }
            .cankaotxt{
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #343434;
              line-height: 30px;
            }
          }
        }
        .shang{
          width: 100%;
          background-color: #F7F7F7;
          margin-top: 20px;
          .shang_nav{
            width: 80%;
            overflow: hidden;
            margin: 0 auto;
            .shangl,.shangr{
              width: 45%;
              float: left;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              color: #000000;
              line-height: 48px;
              cursor: pointer;
              white-space: nowrap;//强制字体不换行
              text-overflow: ellipsis;//超出字体隐藏
              overflow:hidden;
              span:hover{
                color: var(--biao);
                text-decoration: underline;
              }
            }
            .shangl{
              margin-right: 10%;
            }
            .shangl2,.shangr2{
              width: 100%;
              text-align: center;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              color: #000000;
              line-height: 48px;
              cursor: pointer;
              white-space: nowrap;//强制字体不换行
              text-overflow: ellipsis;//超出字体隐藏
              overflow:hidden;
              span:hover{
                color: var(--biao);
                text-decoration: underline;
              }
            }
          }
        }
        .browse_recommend{
          width: 100%;
          overflow: hidden;
          margin-top: 49px;
          .one{
            width: 43%;
            float: left;
            overflow: hidden;
            margin-top: 14px;
            .one_xu{
              width: 85%;
              height: 1px;
              border-bottom: 1px dashed #E4E4E4;
              display: block;
              float: left;
            }
            .one_xian{
              width: 15%;
              height: 1px;
              background-color: var(--biao);
              display: block;
              float: left;
            }
          }
          .browse_recommendtxt{
            width: 14%;
            float: left;
            text-align: center;
            font-size: 20px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #000000;
            line-height: 28px;
          }
          .two{
            width: 43%;
            float: left;
            overflow: hidden;
            margin-top: 14px;
            .two_xu{
              width: 85%;
              height: 1px;
              border-bottom: 1px dashed #E4E4E4;
              display: block;
              float: left;
            }
            .two_xian{
              width: 15%;
              height: 1px;
              background-color: var(--biao);
              display: block;
              float: left;
            }
          }
        }
        .recommendtxt_list{
          width: 99.8%;
          border: 1px solid #EBEBEB;
          padding: 30px 0 36px 0;
          margin-top: 43px;
          .express_nav2r {
            width: 95%;
            overflow: hidden;
            margin: 0 auto;
            .express_list2 {
              width: 100%;
              overflow: hidden;
              cursor: pointer;
              margin-bottom: 45px;
              line-height: 20px;
              .express_dian {
                width: 10px;
                height: 10px;
                background: #DBDBDB;
                border-radius: 50%;
                margin-right: 25px;
                float: left;
                margin-top: 5px;
              }

              .express_wen {
                width: 91%;
                float: left;

                .wen1 {
                  width: 100%;
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #000000;


                  .span3 {
                    width: 100%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    float: left;
                  }
                }

                .wen2 {
                  width: 100%;
                  font-size: 14px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #636363;
                  margin-bottom: 10px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }

              .zhai {
                width: 90%;
                padding-left: 31px;
                overflow: hidden;
                float: left;

                .wen3 {
                  width: 50%;
                  font-size: 14px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #636363;
                  float: left;
                }

                .zhai_left,
                .zhai_right {
                  font-size: 14px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #000000;
                  float: right;
                }

                .zhai_right {
                  margin-left: 30px;
                }

                .zhai_left:hover {
                  text-decoration: underline;
                  color: var(--biao);
                }

                .zhai_right:hover {
                  text-decoration: underline;
                  color: var(--biao);
                }
              }
            }
            .express_list2:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  .add1 {
    color: var(--xt) !important;
    text-decoration: underline;
  }

  .add2 {
    background-color: var(--xt) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/secondary/serial_details.vue